import React , { Component} from 'react';
//import { Link } from 'react-router-dom';
import Media from 'react-media';
//import { Popover, PopoverInteractionKind, Position } from '@blueprintjs/core';
//import UserMenuPopover from './UserMenuPopover';
import NavbarMobile from './NavbarMobile';
import NavbarDesktop from './NavbarDesktop';
import './Navbar.css';

class Navbar extends Component {//= ({ handleLogout, history, location, match, userName, userType, seasons, seasonsList, userSeason }) => {

  render(){
    const { userSeason, handleLogout, history ,location, match, userName, userType, seasons, seasonsList, changeUserSeason } = this.props;

    return(
      <Media query="(max-width: 760px)">
        {matches =>
          matches ? (
            <NavbarMobile
              handleLogout={handleLogout}
              history={history}
              location={location}
              match={match}
              userName={userName}
              userType={userType}
              seasons={seasons}
              seasonsList={seasonsList}
              userSeason={userSeason}
              changeUserSeason={changeUserSeason}
            />
          ) : (
            <NavbarDesktop
              handleLogout={handleLogout}
              history={history}
              location={location}
              match={match}
              userName={userName}
              userType={userType}
              seasons={seasons}
              seasonsList={seasonsList}
              userSeason={userSeason}
              changeUserSeason={changeUserSeason}
            />
          )
        }
      </Media>
    );  
  }
};

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar.js